export const loginApiPaths = {
    initiateLogin: '/v1/accounts/createAuthURI',
    signInWithIDP: '/v1/accounts/signInWithIDP',
    refreshToken: '/v1/token/refresh',
    sendVerificationCode: '/v1/accounts/sendVerificationCode',
    signInWithOTP: '/v1/accounts/signInWithOTP',
};
export const CODE_CHALLENGE_ALGORITHM = 'S256';
export const PROVIDER = 'IDENTITY_PROVIDER_AZURE';
export const REDIRECT_URI = '/instamart/login/success';
export const HOST_NOT_FOUND_ERROR = 'host not found for this environment';
